// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"bdc319f5","787":"accc5588"}[chunkId] + ".chunk.js";
};